import React, { useEffect } from 'react'

import { pdfFileName } from '@helpers/pdfFileName'
import { FilesPDF } from '@models/course.model'
import { coursesAPI } from '@services/CoursesAPI'
import Lottie from 'lottie-react'

import BlueLodaer from '../JsonLottie/BlueLoader.json'
import { LoaderStyles } from '../Loader/style'
import { fileStyle } from './style'

const {
	ContainerButton,
	IconContainer,
	IconCheckmark12Filled,
	DocumentPdf20RegularStyled,
} = fileStyle

const { Container } = LoaderStyles

interface FilePDFProps extends FilesPDF {
	isBlocked?: boolean
	onBlockedAction?: (fileData: {
		name: string
		file: string
		id: number
	}) => void
	forceSuccess?: boolean
	moduleId?: number
}

export const FilePDF = ({
	name,
	file,
	id,
	downloaded,
	isBlocked,
	onBlockedAction,
	forceSuccess,
	moduleId,
}: FilePDFProps) => {
	const [getFilePDF, { isSuccess, isLoading, data }] =
		coursesAPI.useGetFilePdfMutation()

	function saveAs(blob: Blob, fileName: string) {
		const anchor = document.createElement('a')

		anchor.download = pdfFileName(fileName)
		anchor.href = URL.createObjectURL(blob)
		anchor.click()
		URL.revokeObjectURL(anchor.href)
	}

	const handleDownload = (
		event: React.MouseEvent<HTMLButtonElement, MouseEvent>
	) => {
		event.preventDefault()

		if (isBlocked && onBlockedAction) {
			onBlockedAction({ name, file, id })

			return
		}

		getFilePDF({ name: file, fileId: id, moduleId })
	}

	useEffect(() => {
		if (isSuccess && data) {
			saveAs(data, name)
		}
	}, [isSuccess, data, name])

	const isCompleted = !!downloaded || isSuccess || !!forceSuccess

	return (
		<ContainerButton
			type='button'
			onClick={handleDownload}
			isSuccess={isCompleted}
		>
			<IconContainer isSuccess={isCompleted}>
				{isLoading ? (
					<Container>
						<Lottie animationData={BlueLodaer} loop />
					</Container>
				) : (
					<>
						<DocumentPdf20RegularStyled />
						{isCompleted && <IconCheckmark12Filled />}
					</>
				)}
			</IconContainer>

			<p>{name}</p>
		</ContainerButton>
	)
}
